import { render, staticRenderFns } from "./EditSciApplication.vue?vue&type=template&id=56c4562a"
import script from "./EditSciApplication.vue?vue&type=script&lang=js"
export * from "./EditSciApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports